// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__P7eJI","item":"Nav_item__7iHVp","activeLink":"Nav_activeLink__Uk55f","itemFreands":"Nav_itemFreands__1mpx+","personStyle":"Nav_personStyle__WVlBs"};